import type { GamificationBalance } from '@/modules/Gamification/interface/Gamification';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';
import { authKeys } from '@/config/keys';
import { getCookie } from '@/utils/cookies';
import { checkIsTokenValid } from '@/utils/jwt';

const getGamificationBalance = async (): Promise<GamificationBalance> => {
  const authToken = getCookie(authKeys.authToken);

  if (!checkIsTokenValid(authToken)) {
    return { balance: 0, unauthorized: true };
  }

  try {
    throw new Error('Gamification is not implemented');
    const { data } = await api.get(apiConfig.routes.gamification.balance);
    return data;
  } catch (error) {
    return { balance: 0 };
  }
};

export const useGetGamificationBalance = () =>
  useQuery({
    queryKey: ['gamification', 'balance'],
    queryFn: getGamificationBalance,
  });
